import type { McpDiscoveryAuthModelDto } from '@terra/shared-contracts-mcp-servers';
import { mcpServersClient } from './mcp-servers.client';

export async function discoverMcpServerOAuthScopes({
  serverId,
  identityId,
}: {
  serverId: string;
  identityId?: string;
}): Promise<McpDiscoveryAuthModelDto | null> {
  const response = await mcpServersClient.discoverMcpServerOAuthScopes({
    params: { id: serverId },
    query: identityId ? { identityId } : {},
  });

  if (response.status === 200) {
    return response.body;
  }

  return null;
}
